<script setup lang="ts">
import type { Result } from "./results"

defineProps<{
  name: string
  selections: Result[]
  useInputValueByDefault: boolean
  userInput?: string
}>()
</script>

<template>
  <template v-if="selections.length > 0">
    <input
      v-for="selection in selections"
      :key="selection.id"
      type="hidden"
      :name="name"
      :value="selection.text1"
    >
  </template>

  <input
    v-else-if="useInputValueByDefault"
    type="hidden"
    :name="name"
    :value="userInput"
  >

  <input
    v-else
    type="hidden"
    :name="name"
  >
</template>
